import React from "react";
import TugHistory from "../../common/TugHistory";
const FrontHistory = () => <TugHistory reportType="front" />;
export default FrontHistory;
